import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Product } from '../../data/products';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden" data-id="element-574">
      <div className="aspect-square overflow-hidden bg-slate-100" data-id="element-575">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-576" />
      </div>

      <div className="p-6" data-id="element-577">
        <div className="flex items-start justify-between mb-2" data-id="element-578">
          <h3 className="text-xl font-bold text-[#1a2332]" data-id="element-579">{product.name}</h3>
          <span className="text-xl font-bold text-[#dc2626]" data-id="element-580">
            ${product.price}
          </span>
        </div>

        <p className="text-sm text-slate-600 mb-4" data-id="element-581">{product.availableIn}</p>

        <Link to={`/merch/${product.id}`} data-id="element-582">
          <Button variant="outline" className="w-full border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white" data-id="element-583">
            View Options
          </Button>
        </Link>
      </div>
    </div>;
}